if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;

        /*
          Site uses Rebuy Smart Cart as the primary cart UI. Smart Cart's
          document-level form interceptor handles /cart/add.js and opens its
          drawer, so the theme does NOT bind its own submit listener (doing
          so caused a duplicate /cart/add.js fetch and Rebuy's
          "Double add-to-cart detected and compensated" warning).

          If Rebuy fails to load (third-party blocked etc.), the form
          submits naturally as POST /cart/add and the browser redirects to
          /cart — the Dawn cart page is the no-JS fallback.

          The legacy onSubmitHandler / handleErrorMessage methods are
          retained for backwards-compat (anything that may call them
          programmatically), but are not bound to the submit event.
        */

        this.submitButton = this.querySelector('[type="submit"]');
        this.spinner = this.querySelector('.loading__spinner');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // === START LOADING STATE ===
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // === ERROR CASE ===
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', 'true');
              const defaultSpan = this.submitButton.querySelector('span');
              if (defaultSpan) defaultSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // === SUCCESS CASE ===
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal && this.cart) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );
              if (typeof quickAddModal.hide === 'function') {
                quickAddModal.hide(true);
              }
            } else if (this.cart && typeof this.cart.renderContents === 'function') {
              // Only try to render the native cart if it exists
              this.cart.renderContents(response);
            }

            // === Rebuy Smart Cart: open after successful add, if present ===
            if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
              try {
                Rebuy.SmartCart.show();
              } catch (e) {
                console.warn('Rebuy Smart Cart show() error:', e);
              }
            }
          })
          .catch((e) => {
            console.error('product-form add-to-cart error:', e);
          })
          .finally(() => {
            // === ALWAYS CLEAR LOADING STATE, EVEN ON ERROR ===
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.spinner) {
              this.spinner.classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}